const InputUploadFile = ({ name, register }) => {
    return (
        <input type="file" {...register(name, { required: true })} />
    )
}

export default InputUploadFile
